"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}